<template>
  <div>
    <el-form ref="formData" :model="formData" :rules="rules" label-width="90px">
      <el-row>
        <el-col :span="10">
          <el-form-item
            :label="$l('doc_form_label_type') || '文件类型'"
            prop="docType"
          >
            <el-select
              v-model="formData.docType"
              :disabled="formData.type === 'update'"
              size="small"
              filterable
            >
              <el-option label="图片" value="image"> </el-option>
              <el-option label="文件" value="doc"> </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="formData.docType === 'image'">
        <el-col :span="10">
          <el-form-item
            :label="$l('doc_form_label_upload') || '点击上传'"
            prop="scmFileUrl"
          >
            <el-upload
              class="doc-uploader"
              action="/oss/ossUploadReturnUrlAndFileId"
              :show-file-list="false"
              :data="fileData"
              :headers="fileHeaders"
              :on-success="handleAvatarSuccess1"
            >
              <img
                v-if="formData.scmFileUrl"
                :src="formData.scmFileUrl"
                class="docEvent"
              />
              <i v-else class="el-icon-plus docEvent-uploader-icon"></i>
            </el-upload>
            <el-input
              v-show="false"
              v-model="formData.scmFileUrl"
              size="small"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item
            :label="$l('doc_form_label_thumbnail') || '缩略图'"
            prop="scmThumbImageUrl"
          >
            <el-upload
              class="docSmall-uploader"
              action="/oss/ossUploadReturnUrlAndFileId"
              :show-file-list="false"
              :data="fileData"
              :headers="fileHeaders"
              :before-upload="beforeAvatarUpload"
              :on-success="handleAvatarSuccess2"
            >
              <img
                v-if="formData.scmThumbImageUrl"
                :src="formData.scmThumbImageUrl"
                class="docSmallEvent"
              />
              <i v-else class="el-icon-plus docSmallEvent-uploader-icon"></i>
            </el-upload>
            <el-input
              v-show="false"
              v-model="formData.scmThumbImageUrl"
              size="small"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-else-if="formData.docType === 'doc'">
        <el-col :span="10">
          <el-form-item
            :label="$l('doc_form_label_name') || '文档名称'"
            prop="scmFileName"
          >
            <el-input
              v-model="formData.scmFileName"
              maxlength="50"
              size="small"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item
            :label="$l('doc_form_label_status') || '有效状态'"
            prop="scmFileStatus"
          >
            <el-radio-group
              disabled
              size="small"
              v-model="formData.scmFileStatus"
            >
              <el-radio label="Y">有效</el-radio>
              <el-radio label="N">无效</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :offset="4"></el-col>
        <el-col :span="10">
          <el-form-item
            :label="$l('doc_form_label_upload') || '点击上传'"
            prop="scmFileUrl"
          >
            <el-upload
              class="doc-uploader"
              action="/oss/ossUploadReturnUrlAndFileId"
              :show-file-list="false"
              :data="fileData"
              :headers="fileHeaders"
              :on-success="handleAvatarSuccess1"
            >
              <img
                v-if="formData.scmFileUrl"
                :src="defaultUrl"
                class="docEvent"
              />
              <i v-else class="el-icon-plus docEvent-uploader-icon"></i>
            </el-upload>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24" style="text-align: right;margin-top: 100px">
          <el-button size="small" @click="back">{{
            $l('form_btn_return') || '返回'
          }}</el-button>
          <el-button size="small" type="primary" @click="save">{{
            $l('form_btn_save') || '保存'
          }}</el-button>
        </el-col>
      </el-row>
      <!--      <el-row>-->
      <!--        <el-divider></el-divider>-->
      <!--        <span>标签信息</span>-->
      <!--      </el-row>-->
    </el-form>
  </div>
</template>
<script>
import util from '@/libs/util'
export default {
  data() {
    return {
      // 图片压缩比例
      imgQuality: 0.25,
      formData: {}, // 数据
      fileData: {
        // abs文件上传参数
        expirationsec: 0,
        fileproperty: 'publicfiles',
      },
      fileHeaders: {
        // 文件上传请求头
        tokenTimeOut: 0,
        token: util.token.getToken(),
      },
      thumbImageSpec: '?x-oss-process=image/resize,m_fill,h_100,w_100', // 缩略图规格为100*100
      defaultUrl:
        'http://jscloud-shop.oss-cn-shanghai.aliyuncs.com/202004/9aa6076a3f214b271d2c121c07907dae.JPEG?Expires=1902464647&OSSAccessKeyId=LTAIeUAWRhBQ20Xn&Signature=xpuUijsh%2B8QkFdEtx0tV03eQa68%3D',
      rules: {
        docType: [
          { required: true, message: '请选择文件类型', trigger: 'blur' },
        ],
      },
    }
  },
  methods: {
    init(formData) {
      this.formData = formData
    },
    save() {
      if (
        this.formData.docType === 'image' &&
        !this.formData.scmThumbImageUrl
      ) {
        this.$confirm('是否上传缩略图？', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'info',
        })
          .then((_) => {
            this.$message.info('请上传缩略图！')
          })
          .catch(() => {
            this.saveData()
          })
      } else {
        this.saveData()
      }
    },
    saveData() {
      this.$refs['formData'].validate((valid) => {
        if (valid) {
          if (this.formData.type === 'add') {
            this.$api.scmInfoDocAddApi(this.formData).then(() => {
              this.$message({
                showClose: true,
                message: '保存成功',
                type: 'success',
              })
              this.$emit('back')
            })
          } else if (this.formData.type === 'update') {
            this.$api.scmInfoDocUpdateApi(this.formData).then(() => {
              this.$message({
                showClose: true,
                message: '保存成功',
                type: 'success',
              })
              this.$emit('back')
            })
          }
        }
      })
    },
    // 文件上传
    handleAvatarSuccess1(res, file) {
      if (res.status === 200) {
        this.formData.scmFileCode = res.body.fileId
        this.formData.scmFileUrl = res.body.url
        // this.formData.scmFileUrlThum = res.body.url.split('?')[0] + this.thumbImageSpec
        if (this.formData.docType === 'doc') {
          this.$message.success('上传成功')
        }
      } else {
        this.$message({
          showClose: true,
          message: res.msg,
          type: 'error',
        })
      }
    },
    beforeAvatarUpload(file) {
      const fileSize = file.size / 1024 / 1024 < 0.5
      if (!fileSize) {
        return new Promise((resolve) => {
          const reader = new FileReader()
          const image = new Image()
          image.onload = (imageEvent) => {
            const canvas = document.createElement('canvas')
            const context = canvas.getContext('2d')
            // const width = image.width * this.imgQuality
            // const height = image.height * this.imgQuality
            const width = 200
            const height = image.height * (200 / image.width)
            canvas.width = width
            canvas.height = height
            context.clearRect(0, 0, width, height)
            context.drawImage(image, 0, 0, width, height)
            const dataUrl = canvas.toDataURL(file.type)
            const blobData = this.dataURItoBlob(dataUrl, file.type)
            resolve(blobData)
          }
          reader.onload = (e) => {
            image.src = e.target.result
          }
          reader.readAsDataURL(file)
        })
      }
    },
    dataURItoBlob(dataURI, type) {
      var binary = atob(dataURI.split(',')[1])
      var array = []
      for (var i = 0; i < binary.length; i++) {
        array.push(binary.charCodeAt(i))
      }
      return new Blob([new Uint8Array(array)], { type: type })
    },
    // 缩略图上传
    handleAvatarSuccess2(res, file) {
      if (res.status === 200) {
        this.formData.scmThumbImageCode = res.body.fileId
        this.formData.scmThumbImageUrl = res.body.thumbnailUrl
      }
    },
    back() {
      this.$emit('back')
    },
  },
}
</script>
<style>
.doc-uploader {
  border: 1px dashed #d9d9d9;
  width: 240px !important;
  height: 240px;
  line-height: 240px !important;
  text-align: center;
}
.docEvent-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 240px !important;
  height: 240px;
  line-height: 240px !important;
  text-align: center;
}
.docEvent {
  width: 240px !important;
  height: 240px;
  display: block;
}

.docSmall-uploader {
  border: 1px dashed #d9d9d9;
  width: 135px !important;
  height: 135px;
  line-height: 135px !important;
  text-align: center;
}
.docSmallEvent-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 135px !important;
  height: 135px;
  line-height: 135px !important;
  text-align: center;
}
.docSmallEvent {
  width: 135px !important;
  height: 135px;
  display: block;
}
</style>
